<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
      :loading="false"
  >
    <template #layoutContent>
      <Loader :isLoading="loading">
        <Card container-class="card mb-9">
          <div class="card-body pt-9 pb-0">
            <div class="row mb-8">
              <div class="col-md-10 p-1 mb-9">
              <div class="d-flex align-items-start">
                <div v-html="detail.title"class="me-3" style="flex: 1 1 auto; min-width: 0; word-break: break-word; text-align : justify !important;"></div>
                <div class="d-flex  flex-nowrap align-items-start">
                  <span class="badge badge-primary fw-bolder rounded-end-0 text-uppercase me-1">
                    {{ detail.type }}
                  </span>
                  <span class="badge badge-secondary fw-bolder rounded-start-0 text-uppercase">
                    {{ $t('events.planning.' + detail.type_atelier) }}
                  </span>
                </div>
              </div>

                <div class="text-gray-400 fs-4 fw-bold">
                  <span class=""> <i class="bi bi-calendar text-gray-400"></i> {{ $dateFormatter(detail.date, locale) }} </span>
                  <span class="ms-2"> <i class="bi bi-clock-fill text-gray-400"></i> {{ detail.start_time }}  - {{ detail.end_time }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex flex-column my-4">
                  <Button type="button" btn-class="btn-sm btn btn-primary mb-5" btn-text="button.edit" icon-class="fa fa-edit" @click.prevent="updatePlanning"/>
                </div>
              </div>
            </div>
            <ul class="nav nav-tabs nav-line-tabs fs-6">
              <li class="nav-item cursor-pointer" @click.prevent="toggleTab('planning-program')">
                <a class="nav-link" :class="{'active' : (route.query.tab === 'planning-program' || !route.query.tab) }">{{$t('events.planning.program')}}</a>
              </li>
              <li class="nav-item cursor-pointer" @click.prevent="toggleTab('planning-notes')">
                <a class="nav-link" :class="{'active' : route.query.tab === 'planning-notes' }">{{$t('events.planning.notes.title')}}</a>
              </li>
              <li class="nav-item cursor-pointer" @click.prevent="toggleTab('planning-guests')">
                <a class="nav-link" :class="{'active' : route.query.tab === 'planning-guests' }">{{$t('events.planning.visitors')}}</a>
              </li>
              <li class="nav-item cursor-pointer" @click.prevent="toggleTab('planning-message')">
                <a class="nav-link" :class="{'active' : route.query.tab === 'planning-message' }">{{$t('events.planning.default_message')}}</a>
              </li>
            </ul>
          </div>
        </Card>

        <Card>
          <template #cardBody>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show" :class="{'active' : route.query.tab === 'planning-program' || !route.query.tab }" id="planning-program" role="tabpanel">
                <div class="d-flex justify-content-end">
                  <div class="mb-5">
                    <Button type="new" btn-class="btn-sm ms-3" btn-text="events.planning.add_program" @click.prevent="openProgramModal"></Button>
                  </div>
                </div>

                <div class="d-flex align-items-center border-bottom border-gray-300 px-7 py-5 mb-5">
                  <div class="col-md-5">
                    <span class="label fw-bold">{{ $t('events.programs.title') }}</span>
                  </div>
                  <div class="col-md-4">
                    <span class="label fw-bold">{{ $t('events.programs.duration') }}</span>
                  </div>
                  <div class="col-md-3 text-end">
                    <span class="label fw-bold">{{ $t('actions') }}</span>
                  </div>
                </div>

                <div v-if="programs && Object.values(programs).length > 0">
                  <PlanningProgramRow
                      v-for="(program, index) in programs"
                      :key="index"
                      :program="program"
                      @update-program="updateProgram"
                      @delete-program="deleteProgram"
                  />
                </div>

                <div v-else class="d-flex justify-content-center align-items-center" >
                  <div class="text-center ">
                    <div class="mb-5">
                      <Img src="/assets/media/empty.png" filename="empty.png" alt="" class="mw-100 h-100px h-sm-150px" />
                    </div>
                    <h2 class="fs-2x fw-bolder mb-0">{{ $t('events.programs.noData') }}</h2>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" :class="{'active' : route.query.tab === 'planning-notes' }" id="planning-notes" role="tabpanel">
                <NoteIndex :id="detail.type_id"/>
              </div>
              <div class="tab-pane fade show" :class="{'active' : route.query.tab === 'planning-guests' }" id="planning-guests" role="tabpanel">
                <addGuests :id="detail.id" :detail="detail" :message="message" :variables="mailEnum['EVENT']" @callback="loadPlanningData" @handleUpdatePlanning="updatePlanning"/>
              </div>
              <div class="tab-pane fade show" :class="{'active' : route.query.tab === 'planning-message' }" id="planning-message" role="tabpanel">
                <div class="row">
                  <div class="col-md-12">
                    <CKEditor
                        labelClass="form-label fs-6 text-black"
                        :label="$t('events.planning.message_to_send')"
                        :id="'message-editor'+detail.id"
                        :content="message"
                        @text="getMessage"
                        ref="ckeditor"
                        class="custom-ckeditor"
                        @ready="onEditorReady"
                    />
                    <div class="d-flex justify-content-between mt-5">
                      <Button btn-class="btn-sm" type="new" id="submit_btn" btn-text="setting.button" @click="updateMailData" :isLoading="isLoading"></Button>
                      <ButtonDropdown
                        :btn-title="$t('addVariable')"
                        :search="false"
                        :options="mailEnum['EVENT']"
                        value-field="value"
                        :name-field="locale"
                        v-model="selectedVariable"
                        :border="true"
                        :showIcon="true"
                        icon="fas fa-plus"
                        :hideAngle="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Card>
      </Loader>
    </template>
  </SubLayout>
  <PlanningFormModal id="edit_event_planning_modal" :edit="true" :form="formUpdate" @load="loadPlanningData"/>
  <ProgramFormModal id="add_program_modal" :atelierId="detail?.type_id" :atelierDate="detail.date" @load="loadData"/>
  <ProgramFormModal id="edit_program_modal" :edit="true" :form="formProgram" :atelierDate="detail.date" :atelierId="detail?.type_id" @load="loadData"/>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import CKEditor from "@/components/CKEditor.vue";
import Button from "@/components/Button.vue";
import ButtonDropdown from "@/components/OutlineButtonDropdown.vue";
import Loader from "@/components/Loader.vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Card from "@/Modules/Financial/components/Card.vue";
import PlanningFormModal from "@/Modules/Events/views/Planning/modals/PlanningFormModal.vue";
import ProgramFormModal from "@/Modules/Events/views/Planning/modals/ProgramFormModal.vue";
import {$dateFormatter} from "@/mixins/Helpers";
import {useLocales} from "@/composables/locales";
import PlanningProgramRow from "@/Modules/Events/views/Planning/components/PlanningProgramRow.vue";
import {useSwal} from "@/composables/useSwal";
import Img from "@/components/Img.vue";
import AddGuests from "@/Modules/Events/views/Planning/modals/components/addGuests.vue";
import NoteIndex from "@/Modules/Events/views/Notes/Index.vue";

const { locale } = useLocales()
const route = useRoute()
const router = useRouter()
const {showSwal} = useSwal()

const store = useStore()

const title = ref( "events.title")
const breadcrumbs = ref([
  {
    name: 'events.list',
    route: 'events-index'
  },
  {
    name: 'events.detail',
    route: 'events-view',
    params: route.params.id,
    query: { tab: 'tab-planning' }
  },
  {
    name: 'events.detailPlanning',
    route: 'events-planning-view',
    params: {id: route.params.id, planning: route.params.planning},
  }
])

const loading = ref(false)
const detail = ref({})
const formUpdate = ref({
  id: '',
  event_id: '',
  atelier: false,
  program: [
    {
      id: '',
      title: '',
      date: '',
      start_time: '',
      end_time: '',
      description: '',
      moderator_id: '',
      presentator_id: '',
      type_atelier: 'public',
      type_program: 'NONE'
    }
  ]
})
const formProgram = ref({
  id: '',
  atelier_id: '',
  program: [
    {
      title: '',
      date: '',
      start_time: '',
      end_time: '',
      description: ''
    }
  ]
})
const message = ref('')
const selectedVariable = ref('')
const ckeditor = ref(null);
const isLoading = ref(false);

const currentPlanning = computed(() => store.getters['planning/getCurrentPlanning'])

const programs = computed(() => store.getters['planning/getAtelierPrograms'])
const mailMessage = computed(() => store.getters['mail/getMailMessage'])
const mailEnum = computed(() => store.getters['mail/getEmailEnum'])
const mailEvent = computed(() => {
  return mailMessage.value?.filter((item) => {
    return item?.type?.value == 'EVENT_PRIVATE_INVITATION';
  })
})

watch(() => detail.value, (value) => {
  if(value) {
    loadData()
  }
})

watch(() => selectedVariable.value, (value) => {
  insertVariable()
})

watch(() => mailEvent.value, (value) => {
  if(value) {
    message.value = value[0].content
  }
})

watch(() => currentPlanning.value, (value) => {
  if(value) {
    detail.value = value
  }
}, { deep: true })

function updateMailData() {
  isLoading.value = true
  store.dispatch('mail/updateMail', {content: message.value, id: mailEvent.value[0]?.id}) 
    .then((response) => {
      window.toastr['success'](i18n.global.t('setting.setting_message'));
      isLoading.value = false
    })
    .catch(err => {
      isLoading.value = false
    });
}

function toggleTab(tabId){
  router.replace({ query: { ...route.query, tab: tabId } });
}

function insertVariable(){
  if (!ckeditor.value || !ckeditor.value.editorInstance) return;

  const editor = ckeditor.value.editorInstance;
  const variableText = selectedVariable.value;

  editor.model.change(writer => {
    const insertPosition = editor.model.document.selection.getFirstPosition();
    writer.insertText(variableText, insertPosition);
  });
}

function getMessage(text) {
  message.value = text
}

function onEditorReady(editor) {
  ckeditor.value.editorInstance = editor;
}


function loadData() {
  store.dispatch('planning/loadAtelierPrograms', detail.value?.type_id)
}

function updatePlanning() {

  const date = detail.value?.date;
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}-${month}-${year}`;

  formUpdate.value.event_id = detail.value?.model_id
  formUpdate.value.id = detail.value?.id
  formUpdate.value.program = []
  formUpdate.value.atelier = detail.value?.type_program == 'ATELIER' ? true : false

  let program = []
  program.push({
    id: detail.value?.id,
    title: detail.value?.title,
    date: formattedDate,
    start_time: formatTime(detail.value?.start_time),
    end_time: formatTime(detail.value?.end_time),
    description: detail.value?.description ?? '',
    moderator_id: detail.value?.moderator_id ?? '',
    presentator_id: detail.value?.presentator_id ?? '',
    type_atelier: detail.value?.type_atelier,
    type_program: detail.value?.type_program ?? ''
  })
  formUpdate.value.program = program

  $('#edit_event_planning_modal').modal('toggle')
}

function formatTime(time) {
  let times = time.split(':')
  return times[0] + ':' + times[1]
}

function openProgramModal() {
  $('#add_program_modal').modal('toggle')
}


function updateProgram(item) {
  const date = item?.date;
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}-${month}-${year}`;

  formProgram.value.id = item?.id
  formProgram.value.atelier_id = item?.model_id
  formProgram.value.program[0].title = item?.title
  formProgram.value.program[0].date = formattedDate
  formProgram.value.program[0].start_time = item?.start_time
  formProgram.value.program[0].end_time = item?.end_time
  formProgram.value.program[0].description = item?.description

  $('#edit_program_modal').modal('toggle')
}

function deleteProgram(data) {
  showSwal(
      i18n.global.t('events.programs.swal_deleted'),
      i18n.global.t('events.programs.swal_deleted_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('planning/deleteProgram', {id: data.id, atelier_id: data.model_id})
          .then(() => {
            loadData()
            window.toastr['success'](i18n.global.t('events.programs.deleted_successfully'))
          })
          .catch(() => {

          })
    }
  })
}

function loadPlanningData() {
  loading.value = true;
  store.dispatch('planning/getEventPlanning', {id: route.params.planning, event_id: route.params.id})
      .then((res) => {
  }).finally(() => loading.value = false)
}

onMounted(() => {
  loadPlanningData()
  store.dispatch('events/loadParticipators', route.params.id)
  store.dispatch('mail/loadMailMessage')
  store.dispatch('mail/loadEnumEmailMessage')
  store.dispatch('events/getEventDetail', route.params.id)
})
</script>

<style scoped>
</style>